import { render, staticRenderFns } from "./SonScene.vue?vue&type=template&id=77eed0a5&scoped=true&"
import script from "./SonScene.vue?vue&type=script&lang=js&"
export * from "./SonScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77eed0a5",
  null
  
)

export default component.exports